/**
 * shared/nav.ts —— 侧栏导航与登录人信息
 * 来历：一期 [SEC:router] 段的 renderNav()，加上 navfoot（一期写死「周晓 / 项目组管理员」）。
 *
 * 🔴 与一期的差别：**登录人信息来自 /api/auth/me，不是写死的**。
 *   一期是固定管理员视角，navfoot 是一段静态 HTML；二期 P1 一上线就是全员真实登录。
 */
import { esc } from './dom.js';
import { NAV, navIcon } from './icons.js';
import { state } from './state.js';
import * as meta from './meta.js';
import type { PersonType } from '@shared-types';

/** 人员类型的中文名。⚠ 【唯一出处】，别在各页面各写一份；管理后台人员表也 import 它 */
export const TYPE_LABEL: Record<PersonType, string> = {
  member: '正式成员',
  volunteer: '志愿者',
  mentor: '内部导师',
  external: '外部导师',
  admin: '项目组管理员',
  executive: '访客',
};

export function renderNav(): void {
  const nl = document.querySelector('#navlist');
  if (nl) {
    const cur = state.view === 'detail' ? state.from : state.view;
    /* ⚠ 管理后台仅管理员可见、项目快报仅管理员与队长可见：入口留着会让人点进去再被弹回首页，白点一次。
       （快报 2026-10-19 起对队长开放，权限与管理员一致；队员 / 导师 / 访客仍没有入口。）
       ⚠ 这是【显示】不是权限——服务端 requireAdmin / requireAdminOrLead 才是拦截（红线 4）。 */
    const visible = (href: string): boolean =>
      href === '#/admin/periods' ? meta.isAdmin() : href === '#/bulletins' ? meta.isAdminOrLead() : true;
    const items = NAV.filter(([, , href]) => !href || visible(href));
    nl.innerHTML = items.map(([name, d, href]) => {
      /* '#/' → overview，'#/teams' → teams，'#/admin/periods' → admin；新增模块只要加一行 NAV。
         只取第一段：带默认子页的 hash（如管理后台）也能正确匹配到 state.view */
      const key = href ? (href === '#/' ? 'overview' : href.replace('#/', '').split('/')[0]) : null;
      const on = key && key === cur;
      return (
        `<button ${href ? `data-nav="${href}"` : 'aria-disabled="true"'} ${on ? 'aria-current="page"' : ''}>` +
        navIcon(d) +
        `<span class="nlab">${esc(name)}</span>${href ? '' : '<span class="ntag">后续</span>'}</button>`
      );
    }).join('');
  }

  const nf = document.querySelector('#navfoot');
  if (!nf) return;
  const u = meta.me();
  if (!u) {
    nf.innerHTML = '';
    return;
  }
  const role = TYPE_LABEL[u.type];
  nf.innerHTML = `<button class="me" data-lg="logout" aria-label="当前登录：${esc(u.name)}，${esc(role)}；点击退出登录">
      <i>${esc(u.name.slice(0, 1))}</i>
      <span class="me-txt"><b>${esc(u.name)}</b><s>${esc(role)}</s></span>
      <span class="me-chev" id="me-chev" aria-hidden="true"></span>
    </button>`;
}
